<template>
  <div class="sp-template">
    <div class="h-title">业务员目标货量统计</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" class="header-search__form" size="small" label-width="90px">


          <el-row>
            <el-form-item label="月份">
              <el-date-picker v-model="queryForm.month" type="month" format="yyyy-MM" value-format="yyyy-MM"
                placeholder="月份"></el-date-picker>
            </el-form-item>

            <el-form-item label="业务员" v-if="isSalesman==false">
              <el-select v-model.lazy="queryForm.salesman" filterable clearable>
                <el-option v-for="(d, i) in salesmans" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

          </el-row>

          <div class="search-form__buttons">
            <el-button type="primary" size="small" @click="searchTask()" v-if="in_configs(80701)">查询</el-button>


          </div>
        </el-form>
      </div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button type="warning" v-if="in_configs(80702)" size="small" @click="importPop()">导入</el-button>
          <el-button type="warning" v-if="in_configs(80703)" size="small" @click="exportExcel(1)">导出</el-button>
        </div>
      </div>

      <el-table :data="tableData" stripe border style="width: 100%">

        <el-table-column prop="month" label="月份"></el-table-column>
        <el-table-column label="业务员">
          <template slot-scope="scope">
            {{salesmansMaps[scope.row.salesman]}}
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="目标货量"></el-table-column>
        <el-table-column prop="doneWeight" label="完成货量"></el-table-column>
        <el-table-column prop="doneRate" label="完成比例"></el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryForm.currentPage" :page-sizes="pageSizes" :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>


    </el-card>


    <!-- 导入弹框 -->
    <el-dialog title="业务员目标导入" class="common-select__dialog" :visible.sync="dialogCheckVisible" width="30%">

      <el-form size="small" label-width="100px">

        <el-form-item label="导入月份" label-width="120px">
          <el-date-picker v-model="importMonth" type="month" format="yyyy-MM" value-format="yyyy-MM" placeholder="导入月份"
            style="width:200px;"></el-date-picker>
        </el-form-item>

        <el-form-item label="文件上传" label-width="120px">
          <el-upload class="upload-demo" ref="uploadExcel" action="#" :limit="1" :on-exceed="exceedFile"
            :file-list="fileList" :on-change="fileChange" :auto-upload="false" accept=".xlsx">
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx(Excel2007)文件，且不超过10M</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="模板下载" label-width="120px">
          <!-- <a href="../../static/template/salesman_goal.xlsx" class="download-template" >业务员目标模板</a> -->
          <el-link href="../../static/template/salesman_goal.xlsx" target="_blank" type="primary">业务员目标模板</el-link>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="importSubmit()">提交</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
  // import {getFreezeOrder,getUnlock,textPost} from '@/util/reconciliation'
  export default {
    data() {
      return {
        importMonth: "",
        fileList: [],
        templateFile: "",
        dialogCheckVisible: false,
        salesmans: [],
        salesmansMaps: {},
        isSalesman: false,
        queryForm: {
          month: '',
          salesman: '',
          export: 0,

          pageSize: 10,
          currentPage: 1

        },
        tableData: [],
        //分页的数据
        pageSizes: [10, 50, 100, 10000],
        total: 0

      };
    },
    created() {
      let _this = this;

      setTimeout(() => {
        if (!_this.queryForm.month) {
          _this.queryForm.month = this.dateFormat(new Date(), 'yyyy-MM');
          _this.importMonth = this.dateFormat(new Date(), 'yyyy-MM');
        }

        _this.loadRoleList("业务员");
        _this.query();
      }, 1000);



    },
    methods: {
      //查询业务员和客服
      loadRoleList(role) {
        let _this = this;
        _this.$request1
          .get(
            '/staffrole',
            {
              params: {
                role: role
              }
            },
            {
              withCredentials: true
            }
          )
          .then(function (res) {
            if (res.data.success) {
              if (role == "业务员") {
                _this.salesmans = res.data.data;

                _this.salesmans.forEach(a => {
                  _this.salesmansMaps[a.id] = a.name
                })

              }
            } else {
              _this.salesmans = [];
              _this.$message.error(res.data.message);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      searchTask() {
        this.queryForm.currentPage = 1;
        this.query();
      },
      query() {
        let _this = this

        if (!this.queryForm.month) {
          _this.$message.error('月份不能为空');
          return;
        }
        _this.$request1
          .post(
            '/report/salesman-goal',
            _this.queryForm,
            {
              withCredentials: true
            }
          )
          .then(function (res) {
            if (res.data.success && res.data.total>0) {
              _this.total = res.data.total;
              _this.tableData = res.data.data.list;
              _this.isSalesman = res.data.data.salesman;
            }else {
              _this.total = 0;
              _this.tableData = [];              
            }
          }).catch(err => {
            console.log(err)
          })

      },
      exportExcel(val) {
        let _this = this;

        if (!this.queryForm.month) {
          _this.$message.error('月份不能为空');
          return;
        }

        _this.queryForm.export = val;

        this.$request1({
          url: '/report/salesman-goal',
          method: 'post',
          data: this.queryForm,
          responseType: 'blob'
        }).then(res => {
          _this.queryForm.export = 0
          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `salesman-goal_report_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })

      //   var url = tmsSpringUrl + '/report/salesman-goal';

      //   var form = document.createElement("form");
      //   form.method = "post";
      //   form.action = url;
      //   form.target = "_blank";
      //   document.body.appendChild(form);

      //   for (var key in this.queryForm) {
      //     let input = document.createElement("input");
      //     input.type = "hidden";
      //     input.name = key;
      //     input.value = this.queryForm[key];
      //     form.appendChild(input);
      //   }

      //   var input2 = document.createElement("input");
      // input2.type = "hidden";
      // input2.name = "token";
      // input2.value = this.$getToken()
      // form.appendChild(input2);

      //   form.submit();

      },
      importPop() {

        this.dialogCheckVisible = true;
      },
      importSubmit() {
        let _this = this;


        let formData = new FormData();
        if (!_this.templateFile || _this.templateFile.length == 0) {
          this.$message.error("请选择文件。");
          return;
        }
        if (!_this.importMonth) {
          this.$message.error("请输入月份");
          return;
        }
        formData.append("template", _this.templateFile);
        formData.append("month", _this.importMonth);

        _this.$request1
          .post(
            '/salesman-goal/import',
            formData,
            {
              withCredentials: true
            }
          )
          .then(function (res) {

            _this.fileList = []
            _this.templateFile = ""

            if (res.data.success) {
              _this.dialogCheckVisible = false;
              _this.$message.success("导入成功");
              // _this.$alert("导入成功");

            } else {
              _this.$alert(res.data.message);
            }
          })
          .catch(function (error) {
            _this.$message.error(error);
          });

      },
      //分页
      handleSizeChange(val) {
        this.queryForm.currentPage = 1;
        this.queryForm.pageSize = val;
        this.query();
      },
      handleCurrentChange(val) {
        this.queryForm.currentPage = val;
        this.query();
      },
      closeUploadFile() {
        this.templateFile = "";
        this.$refs.uploadExcel.clearFiles();
        this.dialogUpLoadVisible = false;
      },
      fileChange(file, fileList) {
        this.templateFile = file.raw;
      },
      exceedFile(file, fileList) {
        fileList[0].name = file[0].name;
        fileList[0].raw = file[0];
        fileList[0].size = file[0].size;
        this.templateFile = file[0];
      },
      exportData(num) {
        let _this = this;
        console.log(this.month);
        if (!_this.month) {
          // _this.$alert('请选择月份');
          _this.$message.error("请选择月份");
          return;
        }

        let url = '/month-report/' + _this.month + '/' + num + ''
        this.$windowOpen1(url)

      },
      dateFormat(date, fmt) {
        var o = {
          "M+": date.getMonth() + 1, //月份
          "d+": date.getDate(), //日
          "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
          "H+": date.getHours(), //小时
          "m+": date.getMinutes(), //分
          "s+": date.getSeconds(), //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          S: date.getMilliseconds() //毫秒
        };
        var week = {
          "0": "/u65e5",
          "1": "/u4e00",
          "2": "/u4e8c",
          "3": "/u4e09",
          "4": "/u56db",
          "5": "/u4e94",
          "6": "/u516d"
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        if (/(E+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (RegExp.$1.length > 1
              ? RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468"
              : "") + week[date.getDay() + ""]
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      }
    }
  };
</script>

<style lang="scss" scoped>
  /deep/ .shouru .el-checkbox__inner {
    border-radius: 50% !important;
  }
</style>
<style scoped>
  .chgstyle>>>.el-checkbox__inner {
    border-radius: 50% !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/report/salesman_goal.vue